import '../App.sass';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import Lottie from "react-lottie-player"
import hobotnica from '../img/hobotnica.json'

function NoPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className='container text-center d-grid'>
      <h1 className='container noPage'>404</h1>
      <Lottie
        loop
        animationData={hobotnica}
        play
        speed={1}
        className="hobotnica"
      />
      <p>
        <Trans i18nKey="text404">Ups, something went wrong!<br/>The page you requested doesn't exist. Check url or try go back.</Trans>
      </p>
      <button className='btn btn-inner' onClick={() => navigate(-1)}>{t('backBtn')}</button>
    </div>
  );
}

export default NoPage;